import React from "react";

const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  onCancel,
  onConfirm,
  confirmText = "Confirm",
  confirmColor = "purple", // default is purple
   showCancelButton = true, // NEW: default true
}) => {
  if (!isOpen) return null;

  // Tailwind color classes based on confirmColor prop
  const colorMap = {
    red: {
      base: "bg-red-600",
      hover: "hover:bg-red-700",
    },
    purple: {
      base: "bg-purple-600",
      hover: "hover:bg-purple-700",
    },
    blue: {
      base: "bg-gray-900",
      hover: "hover:bg-gray-700",
    },
    // You can add more colors here
  };

  const color = colorMap[confirmColor] || colorMap.purple;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-lg p-6 w-80 text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">{title}</h2>
        <div className="text-gray-600 mb-6">
          {typeof message === "string" ? <p>{message}</p> : message}
        </div>
        <div className={`flex gap-4 ${showCancelButton ? "justify-between" : "justify-center"}`}>
  {showCancelButton && (
    <button
      onClick={onCancel}
      className="w-1/2 px-4 py-2 rounded-md bg-gray-300 hover:bg-gray-400 text-gray-800 transition"
    >
      Cancel
    </button>
  )}
  <button
    onClick={onConfirm}
    className={`${showCancelButton ? "w-1/2" : "w-full"} px-4 py-2 rounded-md text-white ${color.base} ${color.hover} transition`}
  >
    {confirmText}
  </button>
</div>

      </div>
    </div>
  );
};

export default ConfirmActionModal;
